const BrowserDatabaseKeys = {
    localStorage: {
        myKey: "myKey",
    },
    sessionStorage: {
        user: "user",
    },
    cookies: {
        myKey: "myKey",
        authorization: "isLogged",
    },
}


export default BrowserDatabaseKeys